import { action } from 'satcheljs';

export interface OnLaunchMetaOsAddInActionMessage {
    appId: string;
}
const onLaunchMetaOsAddIn: (
    message: OnLaunchMetaOsAddInActionMessage
) => OnLaunchMetaOsAddInActionMessage = action(
    'onLaunchMetaOsAddIn',
    (message: OnLaunchMetaOsAddInActionMessage): OnLaunchMetaOsAddInActionMessage => message
);
export default onLaunchMetaOsAddIn;
